// OrganizerContext.js
import { createContext, useContext, useState } from 'react';

const OrganizerContext = createContext();

export const OrganizerProvider = ({ children }) => {
    const [organizer, setOrganizer] = useState(() => {
        try {
            const stored = localStorage.getItem('organizer');
            return stored ? JSON.parse(stored) : null;
        } catch {
            return null;
        }
    });

    const saveOrganizer = (data) => {
        setOrganizer(data);
        localStorage.setItem('organizer', JSON.stringify(data));
    };

    const [searchValue, setSearchValue] = useState('');

    return (
        <OrganizerContext.Provider value={{ organizer, saveOrganizer, searchValue, setSearchValue }}>
            {children}
        </OrganizerContext.Provider>
    );
};

export const useOrganizer = () => useContext(OrganizerContext);
